// Signature colors per CRMA domain category (tailwind classes).
export const CATEGORY_COLORS = {
    "Internal Audit Roles and Responsibilities": {
        badge: "bg-sky-100 text-sky-900 border-sky-300 dark:bg-sky-950/40 dark:text-sky-200 dark:border-sky-800",
        accent: "border-l-4 border-l-sky-500",
        dot: "bg-sky-500",
        short: "Roles",
    },
    "Risk Management Governance": {
        badge: "bg-emerald-100 text-emerald-900 border-emerald-300 dark:bg-emerald-950/40 dark:text-emerald-200 dark:border-emerald-800",
        accent: "border-l-4 border-l-emerald-600",
        dot: "bg-emerald-600",
        short: "Governance",
    },
    "Risk Management Assurance": {
        badge: "bg-rose-100 text-rose-900 border-rose-300 dark:bg-rose-950/40 dark:text-rose-200 dark:border-rose-800",
        accent: "border-l-4 border-l-rose-500",
        dot: "bg-rose-500",
        short: "Assurance",
    },
    "Mixed": {
        badge: "bg-amber-100 text-amber-900 border-amber-300 dark:bg-amber-950/40 dark:text-amber-200 dark:border-amber-800",
        accent: "border-l-4 border-l-amber-500",
        dot: "bg-amber-500",
        short: "Mixed",
    },
};

export function catStyle(category) {
    return CATEGORY_COLORS[category] || {
        badge: "bg-secondary text-muted-foreground border-border",
        accent: "",
        dot: "bg-muted-foreground/50",
        short: "Uncategorized",
    };
}
